import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import {
	PatientCarePlan,
	PatientCarePlanFactorsData,
	PatientMSKQuestionnnaire,
	PatientScreeningTags,
} from '../types/patients'
import http from './http'

export function mskDetails(patientID: string): AxiosPromise<
	AppApiResponseData<{
		['care_plan']: PatientCarePlan
		['screening_tags']: PatientScreeningTags
	}>
> {
	return http({
		method: 'GET',
		url: `/msk/user/${patientID}`,
	})
}

export function factors(
	patientID: string
): AxiosPromise<AppApiResponseData<PatientCarePlanFactorsData>> {
	return http({
		method: 'GET',
		url: `/msk/user/${patientID}/care-plan/factors`,
	})
}

export function updateCarePlan(
	data: {
		joint: number
		condition: number
		level: string
	},
	patientID: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/msk/user/${patientID}/care-plan`,
		data,
	})
}

export function questionnaire(
	patientID: string
): AxiosPromise<AppApiResponseData<Array<PatientMSKQuestionnnaire>>> {
	return http({
		method: 'GET',
		url: `/msk/user/${patientID}/questionnaire`,
	})
}
